export const firebaseConfig = {
  apiKey: "AIzaSyDh3jrcv6X3nvOVbR5CsxSxhBfy_I5T5s4",
  authDomain: "omnicure-netccn.firebaseapp.com",
  databaseURL: "https://omnicure-netccn-default-rtdb.firebaseio.com",
  projectId: "omnicure-netccn",
  storageBucket: "omnicure-netccn.appspot.com",
  messagingSenderId: "72609671292",
  appId: "1:72609671292:web:b192fd05f60da3143301f9",
  measurementId: "G-B9FRT6LWWL"
};